import { z } from "zod";
export const EmailAlreadyUsedErrorSchema = z.object({
    statusCode: z.literal(400),
    code: z.literal("EMAIL_ALREADY_USED"),
    message: z.string().min(1),
});
//# sourceMappingURL=member.errors.js.map